<div class="lp-own-products">
  <lp-own-products-header
    [title]="'components.loyaltyLpOwnProducts.labels.ownProducts' | translate"
    (add)="addProduct()"
    [allowCreating]="permService.allowedCreating"
    [allowAllStatisticsViewing]="permService.allowedAllStatisticsViewing"
  ></lp-own-products-header>

  <tui-scrollbar
    infiniteScroll
    id="own-products-scrollbar"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
    [alwaysCallback]="true"
    [infiniteScrollDisabled]="!hasMore"
  >
    <app-loader-wrapper [loading]="loading">
      <ng-container *ngIf="products$ | async as products">
        <lp-no-data-found
          *ngIf="products.items && !products.items.length"
          [title]="'components.lpOwnProducts.labels.noProducts' | translate"
          [hideIcon]="true"
          [hideSubtitle]="true"
        >
          <button
            *ngIf="permService.allowedCreating"
            tuiButton
            appearance="secondary"
            type="button"
            [size]="isDesktop ? 'm' : 's'"
            (click)="addProduct()"
          >
            {{ 'common.buttons.add' | translate }}
          </button>
        </lp-no-data-found>
      </ng-container>

      <div class="lp-own-products__products">
        <div class="lp-own-products__products_wrapper">
          <ng-container *ngIf="products$ | async as products">
            <lp-product-card *ngFor="let product of products.items" [product]="product"></lp-product-card>
          </ng-container>
        </div>
      </div>

      <div *ngIf="appending" class="lp-own-products__loading-marker">
        {{ 'components.loyaltyProgram.list.appending' | translate }}
      </div>
    </app-loader-wrapper>
  </tui-scrollbar>
</div>
